// components/features/tickets/TicketSaveModal.tsx
import { useState } from 'react';
import { X } from 'lucide-react';
import TicketForm from './TicketForm';
import { Ticket, TicketSource } from '../../../types/features/Ticket';
import { ticketService } from '../../../services/ticketService';
import BaseModal from '../../ui/Modal';
import { useTicketDraft } from '../../../hooks/features/tickets/useTicketDraft';

interface TicketSaveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  initialData?: Ticket;
  source?: TicketSource;
}

export default function TicketSaveModal({
  isOpen,
  onClose,
  onSuccess,
  initialData,
  source = 'dashboard'
}: TicketSaveModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { clearDraft } = useTicketDraft();

  const handleSubmit = async (data: Omit<Ticket, 'id' | 'created_at' | 'updated_at'>) => {
    setIsLoading(true);
    try {
      if (initialData) {
        await ticketService.updateTicket(initialData.id, data);
      } else {
        await ticketService.createTicket(data);
      }
      clearDraft(); // Supprimer le brouillon après soumission
      setIsLoading(false);
      onSuccess();
      onClose();
    } catch (error: any) {
      console.log(error.response);
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    // Vérifier s'il y a un brouillon
    const hasDraft = localStorage.getItem('ticket_draft');
    if (hasDraft && !initialData) {
      if (!confirm('Vous avez un brouillon non terminé. Voulez-vous le garder pour plus tard ?')) {
        clearDraft();
      }
    }
    onClose();
  };

  const title = initialData ? 'Modifier le ticket' : 'Nouveau ticket';

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
    >
      <TicketForm
        initialData={initialData}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        source={source}
      />
    </BaseModal>
  );
}